import ChipButton from 'app_components/commons/ChipButton/ChipButton';
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent';
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import TooltipComponent from 'app_components/commons/TooltipComponent/TooltipComponent'
import { CertificateSettingType, ICertificateSettings } from 'app_types/admin/certificateSettings/certificateSettings.types'
import React, { FC, useCallback, useMemo, useState } from 'react'
import { Accordion } from 'react-bootstrap';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { MdEdit, MdDelete } from 'react-icons/md';

import './CertificateSettingsCard.scss'
import DataTableComponent from 'app_components/commons/dataTable';
import { ICourseSchedulingDetailListItem } from 'app_types/admin/courseScheduling/courseSchedulingDetailsTypes';
import DurationFieldService from 'app_services/components/durationFieldService';

const CERTIFICATION_TYPE_NAME = {
  [CertificateSettingType.ATTENDANCE]: "Asistencia",
  [CertificateSettingType.ATTENDANCE_APPROVAL]: "Asistencia y aprobación"
}

interface ICertificateSettingsCardProps {
  certificateSettings: ICertificateSettings
  onDelete: () => void
  onEdit: () => void
  courseSchedulingDetails: ICourseSchedulingDetailListItem[]
  disableActions?: boolean
}

const CertificateSettingsCard: FC<ICertificateSettingsCardProps> = ({
  certificateSettings,
  courseSchedulingDetails,
  disableActions,
  onDelete,
  onEdit,
}) => {
  const [activeKey, setActiveKey] = useState<string | undefined>(undefined)
  const durationFieldService = useMemo(() => new DurationFieldService(), [])

  const handleOnSelect = (e: any) => {
    setActiveKey(e)
  }

  const getActiveColor = (certificateType: CertificateSettingType) => {
    if (certificateType === CertificateSettingType.ATTENDANCE) {
      return "#F3DAFF"
    } else {
      return undefined
    }
  }

  const renderIcon = useCallback((selectedKey: string) => {
    if (activeKey === selectedKey) {
      return (<IoIosArrowUp size={18} />)
    }
    return (<IoIosArrowDown size={18} />)
  }, [activeKey])

  const getModuleNameById = (id: string) => {
    const course = courseSchedulingDetails?.find((item) => item._id === id)
    if (course) {
      return course?.course?.name
    }
    return '-'
  }

  const getDataTableItems = () => {
    return certificateSettings?.modules?.map((module) => ({
      ...module,
      // @ts-ignore
      courseSchedulingDetail: getModuleNameById(module?.courseSchedulingDetail?._id),
      exam: module.exam?.status ? `${module?.exam.percentage}%` : '-',
      attendance: module.attendance?.status ? `${module?.attendance.percentage}%` : '-',
      progress_value: module.progress?.status ? `${module?.progress.percentage}%` : '-',
      averageScore: module.averageScore?.status ? `${module?.averageScore.percentage}%` : '-',
      duration: durationFieldService.getDurationFormated(module?.duration),
    }))
  }

  return (
    <div className="certificate-settings-card--layout">
      <div className='certificate-settings-card--content'>
        <TextComponent fontWeight='bold' color='black'>
          {certificateSettings?.certificateName}
        </TextComponent>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <ChipButton width="fit-content" active activeColor={getActiveColor(certificateSettings.certificationType)} padding="0px 10px" >
            {CERTIFICATION_TYPE_NAME[certificateSettings.certificationType]}
          </ChipButton>
          <TextComponent>
            <strong>Duración:</strong> {durationFieldService.getDurationFormated(certificateSettings.duration)}
          </TextComponent>
        </div>
        <Accordion activeKey={activeKey} onSelect={handleOnSelect}>
          <Accordion.Toggle className='certificate-settings-card--toggle' eventKey={`certificate-settings-${certificateSettings._id}`}>
            <div className="certificate-settings-card--accordion-header">
              <LabelComponent>
                Ver módulos ({certificateSettings?.modules?.length})
              </LabelComponent>
              <div className='certificate-settings-card--toggle-icon'>
                {renderIcon(`certificate-settings-${certificateSettings._id}`)}
              </div>
            </div>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey={`certificate-settings-${certificateSettings._id}`}>
            <div className='certificate-settings-card--accordion-content'>
              <DataTableComponent
                data={getDataTableItems()}
                keys={['courseSchedulingDetail', 'progress_value', 'attendance', 'averageScore', 'exam', 'duration']}
                headerKeys={['Nombre', 'Avance', 'Asistencia', 'Nota promedio', 'Examen', 'Duración']}
              />
            </div>
          </Accordion.Collapse>
        </Accordion>
      </div>
      {!disableActions && (
        <div className="certificate-settings-card--actions">
          <TooltipComponent text="Editar certificado">
            <MdEdit onClick={onEdit} />
          </TooltipComponent>
          <TooltipComponent text="Eliminar certificado">
            <MdDelete onClick={onDelete} />
          </TooltipComponent>
        </div>
      )}
    </div>
  )
}

export default CertificateSettingsCard
